import { BaseApiRequest } from '@api/BaseApi';
import { CONGESTION_TYPE } from '@constants';
import moment from 'moment/moment';

export const getCanalDepartures = (data, signal) => {
  return BaseApiRequest(signal, `/Canal/Departures`, 'ships', 'POST', data);
};

export const convertCanalDeparturesData = (canalDeparturesData) => {
  return canalDeparturesData.map((rowData) => {
    let row = { ...rowData };
    let destination = null;

    // Destination port
    if (row.actualNextPort) {
      destination = row.actualNextPort;
    } else if (row.reportedNextPort) {
      destination = row.reportedNextPort;
    } else if (row.destinationPort) {
      destination = row.destinationPort;
    }
    row.destination = destination
      ? {
          name: destination.portName ?? null,
          id: destination.portId ?? null
        }
      : null;
    row.vessel = { name: row.vesselName ?? null, id: row.imo ?? null };
    row.operator = { name: row.operatorShortName ?? null, id: row.operatorId ?? null };
    row.destinationDateETA = row.reportedNextPort?.startDate ?? null;
    row.destinationDateATA = row.actualNextPort?.startDate ?? null;
    row.originATD = row.originPort?.startDate ?? null;
    row.timeUntilArrival = null;
    if (row.eta) {
      if (moment.utc().isBefore(moment.utc(row.eta))) {
        row.timeUntilArrival = moment.utc(row.eta).diff(moment.utc(), 'seconds');
      }
    }
    if (row.originPort) {
      row.originPort = {
        ...row.originPort,
        name: row.originPort.portName,
        id: row.originPort.portId
      };
    }
    return row;
  });
};

export const getCanalArrivals = (data, signal) => {
  return BaseApiRequest(signal, `/Canal/ExpectedArrivals`, 'ships', 'POST', data);
};

export const getCanalInTransit = (data, signal) => {
  return BaseApiRequest(signal, `/Canal/InTransit`, 'ships', 'POST', data);
};

export const getCanalOverview = (data, signal) => {
  return BaseApiRequest(signal, `/RegionData`, 'geo', 'POST', data);
};

export const getCanalWaiting = (data, signal) => {
  return BaseApiRequest(signal, `/CongestionStats`, 'ships', 'POST', {
    ...data,
    congestionType: CONGESTION_TYPE.CANAL
  });
};

export const getCongestionDetails = (data, signal) => {
  return BaseApiRequest(signal, `/Congestion`, 'ships', 'POST', data);
};
